import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useStoreState } from "pullstate";
import useGetNextSteps from "../services/useGetNextSteps";
import Store from "../../../../utils/Store";
import { useAuth } from "@qure/qure-auth";
import useIsProxying from "../../../../utils/useIsProxying";
var useCallGetNextSteps = function useCallGetNextSteps() {
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        patientDetail: s.patientDetail,
        assistantThreadId: s.assistantThreadId
      };
    }),
    patientDetail = _useStoreState.patientDetail,
    assistantThreadId = _useStoreState.assistantThreadId;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  // A proxy session must not change the account being viewed.
  var isProxying = useIsProxying();
  var nextSteps = useGetNextSteps(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, assistantThreadId);
  var callGetNextSteps = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(patientId) {
      var loadingSuggestions, _loadingSuggestions, payload, _res$next_steps, _res$raw_response, res, customSuggestions, _res$next_steps2, jsonString, parsedResponse, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!isProxying) {
              _context.n = 1;
              break;
            }
            Store.update(function (s) {
              s.customSuggestions = [];
            });
            return _context.a(2);
          case 1:
            loadingSuggestions = Store.getRawState().customSuggestions;
            _loadingSuggestions = loadingSuggestions === null || loadingSuggestions === void 0 ? void 0 : loadingSuggestions.map(function (_, index) {
              return {
                title: "Loading...",
                message: ""
              };
            });
            Store.update(function (s) {
              s.customSuggestions = _loadingSuggestions;
            });
            if (!((patientId || patientDetail !== null && patientDetail !== void 0 && patientDetail.patient_id) && Store.getRawState().assistantMode === "workflow")) {
              _context.n = 6;
              break;
            }
            payload = {
              patient_id: patientId || (patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id)
            };
            _context.p = 2;
            _context.n = 3;
            return nextSteps.mutateAsync(payload);
          case 3:
            res = _context.v;
            customSuggestions = [];
            if (res !== null && res !== void 0 && res.next_steps && (res === null || res === void 0 || (_res$next_steps = res.next_steps) === null || _res$next_steps === void 0 ? void 0 : _res$next_steps.length) > 0) {
              customSuggestions = res === null || res === void 0 || (_res$next_steps2 = res.next_steps) === null || _res$next_steps2 === void 0 ? void 0 : _res$next_steps2.map(function (item) {
                return {
                  title: item.display_name,
                  message: item.actual_user_prompt
                };
              });
            } else if (res !== null && res !== void 0 && res.raw_response && (res === null || res === void 0 || (_res$raw_response = res.raw_response) === null || _res$raw_response === void 0 ? void 0 : _res$raw_response.length) > 0) {
              try {
                jsonString = res.raw_response.replace(/^```json\n?/, "").replace(/\n?```$/, "");
                parsedResponse = JSON.parse(jsonString);
                if (parsedResponse !== null && parsedResponse !== void 0 && parsedResponse.next_steps && parsedResponse.next_steps.length > 0) {
                  customSuggestions = parsedResponse.next_steps.map(function (item) {
                    return {
                      title: item.display_name,
                      message: item.actual_user_prompt
                    };
                  });
                }
              } catch (error) {
                console.error("Failed to parse JSON from raw_response:", error);
              }
            }
            Store.update(function (s) {
              s.customSuggestions = customSuggestions;
            });
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error("Failed to get next steps:", _t);
            Store.update(function (s) {
              s.customSuggestions = [];
            });
          case 5:
            _context.n = 7;
            break;
          case 6:
            Store.update(function (s) {
              s.customSuggestions = [];
            });
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function callGetNextSteps(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    callGetNextSteps: callGetNextSteps
  };
};
export default useCallGetNextSteps;